import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Ws from '../providers/Ws';
import { Avatar, Grid } from '@material-ui/core';
import Utils from '../providers/Utils';

export default class CustomUserMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            search:''
        }
    }


    componentDidMount() {
        this.eventListener()
    }



    eventListener = () => {

        let props = this.props
        document.addEventListener('click', function (e) {
            e = e || window.event;


            // console.log('e :>> ', e.path);

            let selectedItem = false

            let paths = [...e.path]

            for (let i = 0, n = paths.length; i < n; i++) {

                // console.log('e.path[i] :>> ', paths[i]);

                if (paths[i].id) {
                    if (paths[i].id.indexOf('selected-target') !== -1) {

                        selectedItem = true
                        break;
                    }
                }

            }

            if (!selectedItem) {
                // console.log('close :>> ');
                props.closeList()
            }



        }, false);



    }

    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }

    filterList = () =>{

        let list = [...this.props.users]

        console.log('list :>> ', list);

        let filteredList = list.filter(l => l.nume.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || l.email.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1)

        return(
            filteredList.map((u, idx) => {
                return (
                    <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div onClick={() => { this.props.selectUser(u) }} className='pm-custom-user-select-option'  >
                            <div>
                                {
                                    u.poza &&
                                    <div
                                        className='pm-angajati-picture'
                                        style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + u.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                    </div>
                                }
                                {!u.poza &&

                                    <Avatar
                                        className='pm-angajati-picture'
                                        style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(u.id) }}>
                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                        {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(u.nume)} </span> */}
                                        <i className='material-icons'>person</i>
                                    </Avatar>
                                    // <Avatar onClick={uClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                }
                                <span onClick={this.goToUser} className='pm-custom-user-select-text'>{u.nume}</span>
                            </div>

                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                paddingRight: 3
                            }}>

                            </div>




                        </div>
                    </Grid>
                )


            })
        )
    }

    render() {
        return (
            <div id={'select-target'}>
                <div style={{ width: this.props.width || '90%', height: '100%', position: 'relative', cursor: 'pointer', display: 'inline-block' }}>
                    {!this.props.showList &&


                        <div>
                            {this.props.user.id ?
                                <div id={'selected-target'} className='pm-custom-user-select' >
                                    <div onClick={this.props.openList} >
                                        {
                                            this.props.user.poza &&
                                            <div
                                                className='pm-angajati-picture'
                                                style={{ backgroundImage: `url('${new Ws().adresaMedia + '/Angajati/' + this.props.user.poza}')`, width: 30, height: 30, marginLeft: 10 }}>

                                            </div>
                                        }
                                        {!this.props.user.poza &&

                                            <Avatar
                                                className='pm-angajati-picture'
                                                style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, height: 30, width: 30, backgroundColor: new Utils().culoriUtilizatori(this.props.user.id) }}>
                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                                                {/* <span style={{ marginTop: '20%', display: 'block' }}>{this.numeAvatar(this.props.user.nume)} </span> */}
                                                <i className='material-icons'>person</i>
                                            </Avatar>
                                            // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(this.props.user.nume + ' ')} </Avatar>
                                        }
                                        <span className='pm-custom-user-select-text'>{this.props.user.nume}</span>
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        paddingRight: 3
                                    }}>
                                        <i onClick={this.props.clearInput} style={{ display: 'block' }} className='material-icons pm-select-user-x-icon'>clear</i>
                                    </div>




                                </div>
                                :
                                <div onClick={this.props.openList} id={'selected-target'} className='pm-custom-user-select' >
                                    <div>
                                        <Avatar
                                            className='pm-angajati-picture'
                                            style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: '#ececec' }}>
                                            <i className='material-icons'>person</i>
                                            {/* <span style={{marginTop:'20%', display:'block'}}>{this.numeAvatar('Selecteaza Utilizator')} </span> */}
                                        </Avatar>
                                        <span onClick={this.goToUser} className='pm-custom-user-select-text'>{this.props.label || 'Selecteaza un angajat'}</span>
                                        {/* <Avatar className='pm-angajati-picture' onClick={this.props.userClick} style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, backgroundColor: 'rgb(241	241	241)' }}>
                        <i style={{ verticalAlign: '-webkit-baseline-middle', color: 'black', }} className='material-icons'>add</i>
                    </Avatar> */}
                                    </div>


                                    <div>
                                        <i style={{ fontSize: 20 }} className='material-icons '>keyboard_arrow_down</i>
                                    </div>
                                </div>



                            }

                        </div>
                    }


                    {this.props.showList &&
                        <div style={{ height: 200, overflow: 'scroll', backgroundColor: '#f1f1f1' }}>
                            <div style={{    border: '1px solid #bdbdbd' }} onClick={this.props.openList} id={'selected-target'} className='pm-custom-user-select' >
                                <div>
                                    <Avatar
                                        className='pm-angajati-picture'
                                        style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: '#ececec' }}>
                                        <i className='material-icons'>person</i>
                                        {/* <span style={{marginTop:'20%', display:'block'}}>{this.numeAvatar('Selecteaza Utilizator')} </span> */}
                                    </Avatar>
                                    <input className='pm-custom-user-select-search-input' 
                                             type='text' 
                                             placeholder='Scrie un nume sau email'
                                             value={this.state.search} 
                                             onChange={(ev)=>{this.setState({search:ev.target.value})}} />
                                    {/* <Avatar className='pm-angajati-picture' onClick={this.props.userClick} style={{ display: 'inline-block', textAlign: 'center', marginLeft: 10, backgroundColor: 'rgb(241	241	241)' }}>
                        <i style={{ verticalAlign: '-webkit-baseline-middle', color: 'black', }} className='material-icons'>add</i>
                    </Avatar> */}
                                </div>


                                <div>
                                    <i style={{ fontSize: 20 }} className='material-icons '>keyboard_arrow_down</i>
                                </div>
                            </div>
                            <Grid container>

                                {this.filterList()}
                            </Grid>

                        </div>
                    }
                </div>

            </div >
        )
    }

}